import React, { useCallback, useState } from 'react'

import { RadioGroup } from '@gousto-internal/citrus-react'

import { usePauseOSRData } from '../../hooks/usePauseOSRData'

interface Props {
  handleSelectedReason: (reason: string) => void
}

const PauseReasons = ({ handleSelectedReason }: Props) => {
  const [selected, setSelected] = useState('')
  const reasons = usePauseOSRData()

  const buildOptions = useCallback(
    () =>
      reasons.map((reason) => ({
        name: 'Radio',
        label: reason.label,
        value: reason.value,
      })),
    [reasons],
  )

  const handleChange = useCallback(
    (event) => {
      setSelected(event.target.value)
      handleSelectedReason(event.target.value)
    },
    [handleSelectedReason],
  )

  return (
    <RadioGroup
      outline
      value={selected}
      onChange={handleChange}
      defaultValue={selected}
      options={buildOptions()}
    />
  )
}

export { PauseReasons }
